import { ConfigFn } from '@config/types'

const config = (({ publication, sportApiUrl, sportApiUrlV2 }) =>
  ({
    baseUrl: sportApiUrl,
    eventUrlTemplate: `/${
      publication === 'romandie' ? 'fr' : 'de'
    }/live-event/{SPORT}/{EVENT_ID}`,

    // SDP V2
    baseUrlV2: sportApiUrlV2,
    eventUrlTemplateV2: `/{SPORT}/{API_VERSION}/live-event/{EVENT_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    standingsUrlTemplateV2: `/{SPORT}/{API_VERSION}/standings/{EVENT_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    relatedMatchesSeasonUrlTemplateV2: `/{SPORT}/{API_VERSION}/related-matches/season/{SEASON_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    relatedMatchesCompetitorUrlTemplateV2: `/{SPORT}/{API_VERSION}/related-matches/competitor/{COMPETITOR_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    recentMatchOutcomesUrlTemplateMatchV2: `/{SPORT}/{API_VERSION}/recent-match-outcomes/match/{MATCH_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    recentMatchOutcomesUrlTemplateCompetitorV2: `/{SPORT}/{API_VERSION}/recent-match-outcomes/competitor/{COMPETITOR_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    sportCompetitorsListUrlTemplateV2: `/{SPORT}/{API_VERSION}/competitors/season/{SEASON_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    sportEntityScheduleCompetitorUrlTemplateV2: `/{SPORT}/{API_VERSION}/schedule/competitor/{COMPETITOR_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    sportEntityScheduleCompetitionUrlTemplateV2: `/{SPORT}/{API_VERSION}/schedule/season/{SEASON_ID}/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
    fmtRelevantMatchesUrlTemplateV2: `/{SPORT}/{API_VERSION}/relevant-matches/${
      publication === 'romandie' ? 'fr' : 'de'
    }`,
  }) as const) satisfies ConfigFn

export default config
